<template>
  <div id="kastaars" v-auto-animate>
    <h1>101 Redenen om te stemmen</h1>
    <div class="container">
      <div class="reason">
        <img v-if="currentSlide?.image && !isRotating" :src="currentSlide.image" />
        <div
          v-if="currentSlide?.video_id && !isRotating"
          :key="currentSlide.video_id"
          class="mychannels"
          data-mychannels-type="video"
          :data-mychannels-id="currentSlide.video_id"
          data-mychannels-options="FUTFU_default"
        />
      </div>
      <Flicking ref="flicking" class="slider" :options="{ circular: true, horizontal: false, align: 'center' }">
        <Slide v-for="reason in reasons" :key="reason.rowId" :reason="reason" />
      </Flicking>
    </div>
  </div>
  <div class="buttons">
    <button @click="nextReason">Geef me nog een reden</button>
    <button @click="openLink">Ik ben overtuigd</button>
  </div>
</template>

<script setup>
import Flicking from '@egjs/vue3-flicking'
import { openExternalUrl, hybrid } from '@dpgradio/creative'
import Slide from './components/Slide.vue'
import { ref, onMounted, computed } from 'vue'
const reasons = ref([])
const flicking = ref(null)
const index = ref(0)
const isRotating = ref(false)

const currentSlide = computed(() => (reasons.value.length > 0 ? reasons.value[index.value] : null))

const ANIMATION_DURATION = 1200

const nextReason = () => {
  isRotating.value = true
  index.value = (index.value + reasons.value.length - 1) % reasons.value.length
  flicking.value?.moveTo(index.value, ANIMATION_DURATION, 'NEXT')
  setTimeout(() => {
    isRotating.value = false
  }, ANIMATION_DURATION)
}

async function fetchReasons() {
  const response = await fetch(
    'https://spreadsheet.radio.dpgmedia.cloud/prod/fetch?tableId=sttmTlgHcyeoPfWr8Y&pageSize=500'
  )
  const data = await response.json()
  reasons.value = data
    .map((reason) => ({ reason, sortKey: Math.random() }))
    .sort((a, b) => a.sortKey - b.sortKey)
    .map((item) => item.reason)
}

onMounted(async () => {
  await fetchReasons()
})

const openLink = () => {
  openExternalUrl('https://stemmen.kastaars.be/', hybrid.OPEN_URL_MODES.EXTERNAL)
}
</script>

<style lang="scss" scoped>
#kastaars {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
}

.reason {
  display: flex;
  justify-content: center;
  align-items: center;
  transition: height 3s ease-in-out;
  max-width: 100vw;

  img {
    max-height: 200px;
    max-width: 100%;
    animation: appear 1s forwards;
  }

  .mychannels {
    width: 400px;
    animation: appearVideo 1s forwards;
  }

  @keyframes appear {
    0% {
      opacity: 0;
      height: 0;
      width: 0;
    }

    100% {
      opacity: 1;
      height: 100%;
      width: 100%;
    }
  }

  @keyframes appearVideo {
    0% {
      opacity: 0;
      height: 0;
      width: 0;
    }

    100% {
      opacity: 1;
      width: 400px;
      height: auto;
    }
  }

  @keyframes disappear {
    0% {
      opacity: 1;
      height: 100%;
      width: 100%;
    }

    100% {
      opacity: 0;
      height: 0;
      width: 0;
    }
  }
}

.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  min-height: 280px;
  max-width: 100%;
}

h1 {
  font-family: 'Cervo';
  text-transform: uppercase;
  font-weight: 800;
  font-size: 1.5rem;
  color: rgb(var(--q-red));
  text-align: center;
}

p {
  font-family: 'Qarla';
  color: rgb(var(--q-red));
}

.buttons {
  display: flex;
  justify-content: center;
  gap: 1rem;

  button {
    font-family: 'Cervo';
    text-transform: uppercase;
    font-weight: 800;
    font-size: 1.5rem;
    letter-spacing: -0.25px;
    background-color: rgb(var(--q-red));
    color: white;
    padding: 0.5rem 1rem;
    border: none;
    border-radius: 0.5rem;
    cursor: pointer;
  }

  @media screen and (max-width: 600px) {
    font-size: 1.2rem;
  }
}

.slider {
  height: 60px;
  overflow: hidden;
  pointer-events: none;
}
</style>
